import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogActions,
  DialogActionsProps,
  DialogContent,
  DialogContentProps,
  DialogProps,
  DialogTitle,
} from "@mui/material";
import { ReactNode } from "react";
import Flex from "./Flex";
import Text from "./Text";
import { Toast, ToastHost } from "./Toast";

type StyledDialogProps = {
  dialogTitle?: ReactNode;
  children: ReactNode;
  open: boolean;
  onClose?: () => void;
  dialogAction?: ReactNode;
  dialogActionsProps?: DialogActionsProps;
  centerTitle?: boolean;
  disableCloseIcon?: boolean;
  dialogContentProps?: DialogContentProps;
  endIcon?: ReactNode;
  errorToast?: Toast | null;
  closeToast?: () => void;
} & DialogProps;

const StyledDialog: React.FC<StyledDialogProps> = ({
  dialogTitle,
  centerTitle,
  children,
  dialogAction,
  disableCloseIcon,
  dialogContentProps,
  dialogActionsProps,
  onClose,
  open,
  endIcon,
  errorToast,
  closeToast,
  ...others
}) => {
  return (
    <Dialog open={open} maxWidth={false} {...others} sx={{ width: "100%" }}>
      <DialogTitle fontSize={"20px"} fontWeight={"medium"}>
        <Flex justifyContent={"space-between"}>
          <Flex
            width={"100%"}
            justifyContent={!!centerTitle ? "center" : undefined}
          >
            {typeof dialogTitle !== "string" ? (
              dialogTitle
            ) : (
              <Text
                fontSize={"16px"}
                fontWeight={"medium"}
                c={others?.color}
                // sx={{ cursor: backButton ? "pointer" : undefined }}
                // onClick={backButton ? onClose : undefined}
              >
                {dialogTitle}
              </Text>
            )}
          </Flex>
          <Flex gap={"10px"} alignItems={"center"} justifyContent={"center"}>
            {endIcon && endIcon}

            {!disableCloseIcon && (
              <CloseIcon onClick={onClose} style={{ cursor: "pointer" }} />
            )}
          </Flex>
        </Flex>

        {errorToast?.message && (
          <ToastHost toast={errorToast} onClose={() => closeToast?.()} />
        )}
      </DialogTitle>

      <DialogContent {...dialogContentProps}>
        <Box paddingTop={1}>{children}</Box>
      </DialogContent>

      <DialogActions {...dialogActionsProps} sx={{ padding: "1.5rem" }}>
        {dialogAction}
      </DialogActions>
    </Dialog>
  );
};

export default StyledDialog;
